module.exports = __webpack_public_path__ + "img/Skimmer_Size.eff1ceda.png";